import {
  CREATECHANELPARTNER,
  GETCHANELPARTNER,
  UPDATECHANELPARTNER,
  DELETECHANELPARTNER,
  GETCHANELPARTNERMAPPING,
  CREATECHANELPARTNERMAPPING,
  UPDATECHANELPARTNERMAPPING,
  DELETECHANELPARTNERMAPPING,
  CREATE_CHANNEL_PARTNER_DOC,
  UPDATE_CHANNEL_PARTNER_DOC,
  GET_CHANNEL_PARTNER_DOC,
  DELETE_CHANNEL_PARTNER_DOC,
   GET_CHANNEL_PARTNER_PAYOUT_ALL,
  GET_CHANNEL_PARTNER_PAYOUT_BALANCE,
    GET_CHANNEL_PARTNER_COMMISSION_LOG,
  GET_CHANNEL_PARTNER_CONTACT_ALL,
} from "../actions/types";

const initialState = {  channelPartnerDocList: [],
    channelPartnerPayoutList: [],
    channelPartnerPayoutBalance: null,
   commissionLogs: [],
  partnerContacts: [], };

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATECHANELPARTNER:
      return {
        ...state,
        channelPartnerSaveStatus: action.payload.success,
      };

    case GETCHANELPARTNER:
      return {
        ...state,
        channelPartnerList: action.payload.data,
      };

    case UPDATECHANELPARTNER:
      return {
        ...state,
        channelPartnerUpdateStatus: action.payload.success,
      };

    case DELETECHANELPARTNER:
      return {
        ...state,
        channelPartnerList: state.channelPartnerList.filter(
          (item) => item.partner_id !== action.partner_id,
        ),
        channelPartnerDeleteStatus: action.payload.success,
      };
    case GETCHANELPARTNERMAPPING:
      return {
        ...state,
        channelPartnerMappingList: action.payload.data,
      };
    case CREATECHANELPARTNERMAPPING:
      return {
        ...state,
        channelPartnerMappingCreateStatus: action.payload.success,
      };

    case UPDATECHANELPARTNERMAPPING:
      return {
        ...state,
        channelPartnerMappingUpdateStatus: action.payload.success,
      };

    case DELETECHANELPARTNERMAPPING:
      return {
        ...state,
        channelPartnerMappingList: state.channelPartnerMappingList.filter(
          (item) => item.mapping_id !== action.mapping_id,
        ),
        channelPartnerMappingDeleteStatus: action.payload.success,
      };
    case GET_CHANNEL_PARTNER_DOC:
      return {
        ...state,
        channelPartnerDocList: action.payload.data,
      };

    case CREATE_CHANNEL_PARTNER_DOC:
      return {
        ...state,
        docSaveStatus: action.payload.success,
      };

    case UPDATE_CHANNEL_PARTNER_DOC:
      return {
        ...state,
        docUpdateStatus: action.payload.success,
      };
    case "DELETE_CHANNEL_PARTNER_DOC":
      return {
        ...state,
        channelPartnerDocList: state.channelPartnerDocList.filter(
          (item) => String(item.id) !== String(action.docId),
        ),
        docDeleteStatus: action.payload.success,
      };
         case GET_CHANNEL_PARTNER_PAYOUT_ALL:
      return {
        ...state,
        channelPartnerPayoutList: action.payload.data,
      };

    case GET_CHANNEL_PARTNER_PAYOUT_BALANCE:
      return {
        ...state,
        channelPartnerPayoutBalance: action.payload.data,
      };
       case GET_CHANNEL_PARTNER_COMMISSION_LOG:
      return {
        ...state,
        commissionLogs: action.payload,
      };

    case GET_CHANNEL_PARTNER_CONTACT_ALL:
      return {
        ...state,
        partnerContacts: action.payload,
      };
    default:
      return state;
  }
}
